'use client';

import { redirect } from 'next/navigation';

export default function AboutRedirect() {
  // Get the user's language from localStorage (default to 'ar')
  const language = localStorage.getItem('i18nextLng') || 'ar';

  // Redirect /about → language-specific about page
  redirect(`/${language}/about`);
}
